"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variable = void 0;
const types_1 = require("@comunica/types");
class Variable {
    expressionType = types_1.ExpressionType.Variable;
    name;
    constructor(name) {
        this.name = name;
    }
}
exports.Variable = Variable;
//# sourceMappingURL=Variable.js.map